<template>
  <div>
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="pageData.pageNum"
      :page-sizes="pageSizes"
      :page-size="pageData.pageSize"
      :layout="layout"
      :total="total"
    ></el-pagination>

    <!-- <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="pageData.pagenum"
      :page-size="pageData.pagesize"
       :page-sizes="pageSizes"
      :layout="layout"
      :total="total"
    ></el-pagination> -->
  </div>
</template>

<script>
export default {
  props: {
    //   页面和页数
    pageData: {
      type: Object,
      default: () => {
        return {
          pageSize: 1, //页码 pagenum  2
          pageNum: 10, //下拉的页数码条数
        };
      },
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 30, 60, 90, 120, 200, 210];
      },
    },
    layout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper",
    },
    // 总页数
    total: {
      type: Number,
      default: 20,
    },
    // 函数
    getTableList: {
      type: Function,
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    handleSizeChange(val) {
      this.$set(this.pageData, "pageSize", val);
      if (this.getTableList) {
        this.getTableList();
      }
    },

    handleCurrentChange(val) {
      if (this.getTableList) {
        this.getTableList();
      }
    },
  },
};
</script>

<style scoped lang="less">
.el-pagination{
  padding: 16px 5px 0;
}
</style>



